import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { checkUserPermissions, useAuth } from "@/features/auth";
import { SubscriptionsLayout, CheckoutFormProvider } from "@/features/subscriptions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Component = () => {
  const { accountDetails } = useAuth();

  if (
    accountDetails?.capabilities?.isSubscriptionButtonAvailable ||
    accountDetails?.capabilities?.isSelfUpgradeAvailable
  ) {
    return (
      <CheckoutFormProvider>
        <SubscriptionsLayout />
      </CheckoutFormProvider>
    );
  }

  return <Navigate to="/consent-solutions" replace />;
};

const Route = createFileRoute("/_authorized/subscription")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW", "SUBSCRIPTION_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <Component />,
});

export { Route };
